import _ from 'lodash';
import React from 'react';
import { AccordionContainer } from '../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../common/components/form/input/containers/input.container';


export const OrgRegistryBasicInfoComponent = ({dbnpregistries, deliveryPreference,accountType,id, selectedOrgRegistry, shippingTypes, shippingProviders, accounts, fetchAcount, orgRegistry, onFormChange }: any) => {
 
    const dayEnum: any = [
        { Description: 'Sunday', Value: 1 },
        { Description: 'Monday', Value: 2 },
        { Description: 'Tuesday', Value: 3 },
        { Description: 'Wednesday', Value: 4 },
        { Description: 'Thursday', Value: 5 },
        { Description: 'Friday', Value: 6 },
        { Description: 'Saturday', Value: 7 }
      ]
      const timeSlots = [
        {
          Disabled: false,
          Selected: false,
          Text: '10 AM to 12 PM',
          Description: '10 AM to 12 PM',
          Value: 10
        },
        {
          Disabled: false,
          Selected: false,
          Text: '12 PM to 2 PM',
          Description: '12 PM to 2 PM',
          Value: 20
        },
        {
          Disabled: false,
          Selected: false,
          Text: '2 PM to 4 PM',
          Description: '2 PM to 4 PM',
          Value: 30
        },
        {
          Disabled: false,
          Selected: false,
          Text: '4 PM to 6 PM',
          Description: '4 PM to 6 PM',
          Value: 40
        },
        {
          Disabled: false,
          Selected: false,
          Text: '24 Hrs',
          Description: '24 Hrs',
          Value: 50
        }
      ]
    return(
        <>
<AccordionContainer
          child={
            <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
              <InputContainer
              isDisabled
                label="Account Type"
                labelField="Text"
                list={accountType}
                onValueChange={(event: any, newValue: any) => {
                  onFormChange({
                    value: event.target.value,
                    field: 'AccountTypeId'
                  });
                } }
                optionName='Choose AccountType'
                type="select"
                value={orgRegistry?.AccountTypeId}
                valueField="Value" />
        
            {orgRegistry?.AccountTypeId
              ? <InputContainer
              isDisabled
                  label="Account Name"
                  labelField="Name"
                  list={accounts}
                  onValueChange={(event: any, newValue: any) => {
                    onFormChange({
                      value: event.target.value,
                      field: 'AccountId'
                    });
                  } }
                  optionName='Choose Account'
                  type="select"
                  value={orgRegistry?.AccountId}
                  valueField="Id" />

              
              : null}

           <InputContainer
             isDisabled
                label="Accept Order By Default Enabled"
                name="IsAcceptOrderByDefaultEnabled"
                onValueChange={(event: any) => {
                  onFormChange({
                    value: event,
                    field: 'IsAcceptOrderByDefaultEnabled'
                  });
                } }
                type="checkbox"
                value={orgRegistry?.IsAcceptOrderByDefaultEnabled} />
            <InputContainer
              isDisabled
                label="Direct Shipment Enabled"
                name="IsDirectShipmentEnabled"
                onValueChange={(event: any) => {
                  onFormChange({
                    value: event,
                    field: 'IsDirectShipmentEnabled'
                  });
                } }
                type="checkbox"
                value={orgRegistry?.IsDirectShipmentEnabled} />
           <InputContainer
             isDisabled
                label="UkId"
                name="UkId"
                onValueChange={(event: any) => {
                  onFormChange({
                    value: event.target.value,
                    field: 'UkId'
                  });
                } }
                type="text"
                value={orgRegistry?.UkId} />
           <InputContainer
             isDisabled
                label="Delivery Preference"
                labelField="Text"
                list={deliveryPreference}
                onValueChange={(event: any, newValue: any) => {
                  onFormChange({
                    value: event.target.value,
                    field: 'Delivery_preference'
                  });
                } }
                optionName='Choose DeliveryPreference'
                type="select"
                value={orgRegistry?.Delivery_preference}
                valueField="Text" />
          
            {orgRegistry?.Delivery_preference === 'Network' && <div>
            <InputContainer
              isDisabled
                label="LogisticProviderAccount Name" 
                labelField="AccountName"
                list={shippingProviders}
                onValueChange={(newValue: any) => {
                  const valueData: any = newValue.map((option: any) => option?.value || '');
                  onFormChange({
                    value: valueData,
                    field: 'PreferredLogisticProviderAccountIds'
                  });
                } }
                type="multiselect"
                valueField="AccountId"
                value={orgRegistry?.PreferredLogisticProviderAccountIds} />
            </div>}
             <InputContainer
               isDisabled
                label="Shipping Type"
                labelField="ShippingTypeName"
                list={shippingTypes}
                onValueChange={(event: any, newValue: any) => {
                  onFormChange({
                    value: event.target.value,
                    field: 'ShippingTypeId'
                  });
                } }
                optionName='Choose ShippingType'
                type="select"
                value={orgRegistry?.ShippingTypeId}
                valueField="Id" />

<InputContainer
  isDisabled
                label="DBNP Registry Name"
                labelField="name_of_authorised_signatory"
                list={dbnpregistries}
                onValueChange={(event: any, newValue: any) => {
                  onFormChange({
                    value: event.target.value,
                    field: 'DBNPRegistryId'
                  });
                } }
                optionName="Choose DBNP Registry"
                type="select"
                value={orgRegistry?.DBNPRegistryId}
                valueField="Id"
              />
           <InputContainer
             isDisabled
                label="GPS"
                name="gps"
                onValueChange={(event: any) => {
                  onFormChange({
                    value: event.target.value,
                    field: 'gps'
                  });
                } }
                type="text"
                value={selectedOrgRegistry?.gps} />
            <InputContainer
              isDisabled
                label="Radius Unit"
                name="unit"
                onValueChange={(event: any) => {
                  onFormChange({
                    value: event.target.value,
                    field: 'unit'
                  });
                } }
                type="text"
                value={selectedOrgRegistry?.unit} />
          <InputContainer
            isDisabled
                label="Radius Value"
                name="value"
                onValueChange={(event: any) => {
                  onFormChange({
                    value: event.target.value,
                    field: 'value'
                  });
                } }
                type="text"
                value={selectedOrgRegistry?.value} />
           <div>   <InputContainer
             isDisabled
                  label="Days" 
                  labelField="Description"
                  list={dayEnum}
                  onValueChange={(newValue: any ) => {
                  const valueData: any = newValue.map((option: any) => option?.value || '');
                  onFormChange({
                    value: valueData,
                    field: 'days'
                  });
                } }
                type="multiselect"
                 valueField="Value"
                value={selectedOrgRegistry?.days} />

</div>
            <div>
            <InputContainer
              isDisabled
               label="Holidays" 
                labelField="Description"
                 list={dayEnum}
                onValueChange={(newValue: any ) => {
                  const valueData: any = newValue.map((option: any) => option?.value || '');
                  onFormChange({
                    value: valueData,
                    field: 'holidays'
                  });
                } }
                type="multiselect"
                valueField="Description"
                value={selectedOrgRegistry?.holidays} />

</div>
           
              <InputContainer
                isDisabled
                label="Frequency"
                name="frequency"
                onValueChange={(event: any) => {
                  onFormChange({
                    value: event.target.value,
                    field: 'frequency'
                  });
                } }
                type="text"
                value={selectedOrgRegistry?.frequency} />
           <div>
           <InputContainer
             isDisabled
                label="Times" 
                 labelField="Description"
                 list={timeSlots}
                 onValueChange={( newValue: any) => {
                  const valueData: any = newValue.map((option: any) => option?.value || '');
                  onFormChange({
                    value: valueData,
                    field: 'times'
                  });
                } }
                type="multiselect"
                valueField="Description"
                value={selectedOrgRegistry?.times} />

</div>
              <InputContainer
                isDisabled
                label="Range Start"
                name="start"
                onValueChange={(event: any) => {
                  onFormChange({
                    value: event.target.value,
                    field: 'start'
                  });
                } }
                type="text"
                value={selectedOrgRegistry?.start} />
             <InputContainer
               isDisabled
                label="Range End"
                name="end"
                onValueChange={(event: any) => {
                  onFormChange({
                    value: event.target.value,
                    field: 'end'
                  });
                } }
                type="text"
                value={selectedOrgRegistry?.end} />
            <InputContainer
              isDisabled
                label="Currently Servicing"
                name="CurrentlyServicing"
                onValueChange={(event: any) => {
                  onFormChange({
                    value: event,
                    field: 'CurrentlyServicing'
                  });
                } }
                type="checkbox"
                value={orgRegistry?.CurrentlyServicing} />
            <InputContainer
              isDisabled
                label="Use Settings From ConfigFile"
                name="UseSettingsFromConfigFile"
                onValueChange={(event: any) => {
                  onFormChange({
                    value: event,
                    field: 'UseSettingsFromConfigFile'
                  });
                } }
                type="checkbox"
                value={orgRegistry?.UseSettingsFromConfigFile} />
          
            {id !== '0' &&
               <InputContainer
               
                  isDisabled
                  label="OrganizationUnit Name"
                  name="OrganizationUnit Name"
                  onValueChange={(event: any) => {
                    onFormChange({
                      value: event.target.value,
                      field: 'OwnedByOUName'
                    });
                  } }
                  type="text"
                  value={orgRegistry?.OwnedByOUName} />

             }
            {id !== '0' &&
              <InputContainer
                  isDisabled
                  label="OrganizationUnit Account Name"
                  name="OrganizationUnit Name"
                  onValueChange={(event: any) => {
                    onFormChange({
                      value: event.target.value,
                      field: 'OwnedByOUAccountName'
                    });
                  } }
                  type="text"
                  value={orgRegistry?.OwnedByOUAccountName} />

             }
          </div>
          }
          expandedPanel="OrgRegistry"
          headerTitle="Org Registry" 
          />
        </>
)}
export default OrgRegistryBasicInfoComponent;
